<template>
  <div>
    <a
      href="#"
      @click="click"
    >
      {{ grapesJSInstance === null ? 'Copy' : 'Select' }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inject: ['onClick'],
  data () {
    return {
      data: {}
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent'
    })
  },
  methods: {
    click () {
      const { link } = this.data
      this.onClick(link)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
